<section class="w-full">
  <split-header-section title="Relatório Despesas"></split-header-section>
  <div class="grid">
    <div class="col-4">
      <div class="bg-white p-6 h-13rem border-round-2xl box-shadow cursor-pointer card-container" pRipple
        (click)="openModalDespesas()">
        <div class="header flex justify-content-between w-full">
          <span class="title"> Pesquisar despesas </span>
        </div>
        <div class="w-full mt-3">
          <span class="subtitle text-base">
            Veja os relatórios das últimas despesas que você cadastrou
          </span>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="bg-white p-6 h-13rem border-round-2xl box-shadow cursor-pointer card-container" pRipple
        [routerLink]="'/relatorios/financeiro/receita'">
        <div class="header flex justify-content-between w-full">
          <span class="title"> Receitas </span>
        </div>
        <div class="w-full mt-3">
          <span class="subtitle text-base">
            Veja os relatórios das últimas receitas que você cadastrou
          </span>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="bg-white p-6 h-13rem border-round-2xl box-shadow cursor-pointer card-container" pRipple
        [routerLink]="'/relatorios/financeiro'">
        <div class="header flex justify-content-between w-full">
          <span class="title"> Relatório financeiro </span>
        </div>
        <div class="w-full mt-3">
          <span class="subtitle text-base">
            Veja os seus últimos relatórios financeiros
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="grid mt-2">
    <div class="col-12">
      <div class="bg-white p-5 border-round-2xl box-shadow">
        <div class="header mb-7 flex justify-content-between">
          <div>
            <span class="title"> Despesas </span> <br />
            <span class="subtitle" *ngIf="!expensesYearFilter">
              Últimos 12 meses
            </span>
          </div>
          <div class="flex align-items-center">
            <split-group-filter id="expensesReport" (onFilterEvent)="onFilterExpenses($event)">
              <split-filter-month groupId="expensesReport" view="year" field="year" key="year"
                label="Ano"></split-filter-month>
              <split-filter-unit groupId="expensesReport" field="unit" key="unit" label="Unidade"></split-filter-unit>
            </split-group-filter>
          </div>
        </div>

        <div class="w-full">
          <div class="valores_mes flex mb-4">
            <div class="mes_atual flex flex-column align-items-start pr-3" style="color: #6d6ccd">
              {{
              this.dataReportExpenses.expenseActual
              | currency : "BRL" : "symbol" : "1.2-2"
              }}
              <span class="subtitle"> Depesas mês atual </span>
            </div>
            <div class="border-pipe mes_anterior flex flex-column align-items-start justify-content-center pl-3">
              {{
              this.dataReportExpenses.expensePrevious
              | currency : "BRL" : "symbol" : "1.2-2"
              }}
              <span class="subtitle"> Depesas mês anterior </span>
            </div>
          </div>
          <split-line [highlightLastLabel]="true" [data]="this.dataReportExpenses.data"
            [labels]="this.dataReportExpenses.labels"></split-line>
        </div>
      </div>
    </div>
  </div>
  <div class="grid mt-2">
    <div class="col">
      <div [style.height]="'35rem'" class="bg-white p-5 border-round-2xl box-shadow">
        <div class="header mb-7 flex justify-content-between">
          <div>
            <span class="title"> Top 5 gastos </span> <br />
            <span class="subtitle" *ngIf="!fiveExpensesYearFilter">
              Último mês
            </span>
          </div>
          <div class="flex align-items-center">

            <split-group-filter id="TopFiveExpenses" (onFilterEvent)="onFilterFiveExpenses($event)">
              <!-- ajustar filtro por mes -->

              <split-filter-month [required]="true" [data]="listData" groupId="TopFiveExpenses" field="month"
                label="Mês" key="month"></split-filter-month>

              <split-filter-unit groupId="TopFiveExpenses" field="unit" key="unit" label="Unidade"></split-filter-unit>
            </split-group-filter>

          </div>
        </div>
        <div class="w-full">
          <ng-template #tooltipTemplate let-colors="colors" let-fullData="fullData" let-activedText="activedText">
            <div>
              <p [style.color]="colors[activedText.index]">
                {{ activedText.title | lowercase }}
              </p>
              <span class="subtitle-tooltip-bars">
                {{ activedText.subtitle | currency : "BRL" }}
              </span>
            </div>
          </ng-template>
          <split-bar [tooltipTemplate]="tooltipTemplate" [allowLegend]="true" [disableCurrency]="true"
            [data]="this.dataReportTopFiveExpenses.data" [columns]="this.dataReportTopFiveExpenses.labels"
            [colors]="['#6D6CCD','#32B1B7','#E38784','#6C9ECD','#FFB84E']" color="#FF8321"></split-bar>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-8 xl:col-4 resultado_anual">
      <div [style.height]="'35rem'" class="bg-white p-5 border-round-2xl box-shadow">
        <div class="header mb-5 flex justify-content-between">
          <div class="w-full">
            <div class="flex mb-4 justify-content-between">
              <div>
                <span class="title"> Despesas anuais </span>
              </div>
              <p-button icon="pi pi-download" class="justify-self-end" severity="secondary" [rounded]="true"
                [text]="true" (onClick)="downloadAnnualExpenses()"></p-button>
            </div>
            <div class="w-full flex justify-content-end">
              <split-group-filter id="AnnualExpenses" (onFilterEvent)="onFilterAnnualExpenses($event)">
                <split-filter-unit groupId="AnnualExpenses" field="unit" key="unit" label="Unidade"></split-filter-unit>
              </split-group-filter>
            </div>
            <br />
            <split-report-message-year-month class="mb-3" *ngFor="let result of annualExpensesGraphic"
              class="expense-card mb-2" [year]="result.ano" [label]="'Faturamento total'"
              [percentage]="result.value.percentage"
              [columns]="[{valor: result.value.expense,descricao: 'Despesas'}]"></split-report-message-year-month>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="grid mt-2">
    <div class="col">
      <split-results-per-month [color]="'#6D6CCD'" [bgColor]="'#f3f3fb'" [disableResultado]="true"
        header="Despesas mês a mês" [columns]="dataMonthToMonthExpense" [expenses]="true"></split-results-per-month>
    </div>
  </div>
  <div class="grid mt-2">
    <div class="col">
      <split-results-per-month [enablePaginator]="false" [color]="'#6D6CCD'" [bgColor]="'#f3f3fb'"
        [disableResultado]="true" header="Despesas por categorias mês a mês" [breakLine]="'col-12'" [expenses]="true"
        [columns]="dataCategoryMonthToMonthExpense"></split-results-per-month>
    </div>
  </div>
</section>